export default {
  fullName: true,
  userName: true,
  displayName: false,
  email: true,
  password: true,
  phoneNummber: true,
  role: true,
  vendor: true
};
